import styled from 'styled-components';
import EditImageView from '../EditImage';

import { subMenuDropdownBackground } from '../../config/colors';

export const LocationAndCraneCoverageWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  padding: 35px 30px 100px 30px;
  background-color: ${subMenuDropdownBackground};
  position: relative;
  justify-content: flex-end;
  flex-direction: column;
`;

export const EditImage = styled(EditImageView).attrs({
  containerStyle: {
    width: '100%',
    height: '300px',
  },
})``;
